<h1 class="row align-center space-between w100">
  <div class="row gap-8 align-center">
    <rr-icon class="streamicon" name="wind" size="Small"></rr-icon>
    Edit {{ streamNameFormControl.value }}
  </div>
  <div class="row gap-8">
    <rr-btn type="Default" iconStart="upload" size="medium">+CSV Upload</rr-btn>
    <rr-btn type="Default" iconStart="download" size="medium"
      >CSV Download</rr-btn
    >
  </div>
</h1>
<div class="w100 tiny col">
  <span
    >created: {{ created }} |
    {{ stream?.creatingUserId | getUsernameById | async }}</span
  >
  <span *ngIf="updated"
    >updated: {{ updated }} |
    {{ stream?.updatingUserId | getUsernameById | async }}</span
  >
</div>
<mat-accordion
  displayMode="default"
  class="w100"
  [hideToggle]="false"
  [multi]="false"
>
  <mat-expansion-panel [hideToggle]="false">
    <mat-expansion-panel-header
      ><h2>Stream Settings</h2></mat-expansion-panel-header
    >
    <div class="col gap-8">
      <form class="w100 col gap-8">
        <rr-input
          label="Stream Name"
          [formControl]="streamNameFormControl"
        ></rr-input>
      </form>
      <form class="w100 col gap-8">
        <rr-textarea
          [label]="'Role (v: ' + streameVersionFormControl.value + ')'"
          [formControl]="streamRoleFormControl"
          (blur)="saveSessionHistory()"
        ></rr-textarea>
        <rr-textarea
          [label]="'Tone (v: ' + streameVersionFormControl.value + ')'"
          [formControl]="streamToneFormControl"
          (blur)="saveSessionHistory()"
        ></rr-textarea>
        <rr-textarea
          [label]="'Context (v: ' + streameVersionFormControl.value + ')'"
          [formControl]="streamContextFormControl"
          (blur)="saveSessionHistory()"
        ></rr-textarea>
      </form>
    </div>
    <mat-action-row class="gap-16 align-center">
      <div class="row gap-8 align-center" *ngIf="sessionHistory.length !== 0">
        <rr-icon
          name="history-back"
          class="pointer"
          (click)="sessionHistoryBack()"
          *ngIf="sessionHistory.length > 1"
        ></rr-icon>
        <rr-icon
          name="history-foreward"
          class="pointer"
          (click)="sessionHistoryForward()"
          *ngIf="
            sessionHistoryIndex < sessionHistory.length - 1 &&
            sessionHistory.length > 1
          "
        ></rr-icon>
      </div>
      <rr-select
        class="versionselect"
        [options]="streamPromptVersions"
        [formControl]="streameVersionFormControl"
        [preselectedValue]="streameVersionFormControl.value"
        optionName="name"
        optionValue="id"
      ></rr-select>
      <rr-btn type="Primary" iconStart="save" (click)="saveStreamSettings()"
        >Save</rr-btn
      >
    </mat-action-row>
  </mat-expansion-panel>
  <mat-expansion-panel [hideToggle]="false" expanded="true">
    <mat-expansion-panel-header><h2>Steps</h2></mat-expansion-panel-header>
    <div
      cdkDropList
      class="example-list w100"
      (cdkDropListDropped)="dropStep($event)"
      *ngIf="stream?.steps.length > 0"
    >
      @for (step of stream?.steps; track step?.id) {
      <div class="example-box w100 row align-center space-between" cdkDrag>
        <div class="row align-center gap-24">
          <span>{{ step?.stepTypeId | getStepTypeNameById }}</span>
          <span>{{ step?.creditCosts }} Credits</span>
        </div>
        <div class="row gap-24 align-center">
          <rr-icon name="trash" color="nutral"></rr-icon>
          <rr-btn
            type="Link"
            class="underline"
            size="medium"
            (click)="editStep(step)"
            >Edit</rr-btn
          >
        </div>
      </div>
      }
    </div>
    <mat-action-row>
      <rr-btn iconStart="add" type="Secondary" (click)="addStep()"
        >Add Step</rr-btn
      >
    </mat-action-row>
  </mat-expansion-panel>
  <mat-expansion-panel [hideToggle]="false">
    <mat-expansion-panel-header><h2>Output</h2></mat-expansion-panel-header>
    <div class="w100 col gap-16">
      <div
        class="outputprompt w100 col gap-8"
        *ngFor="let prompt of outputControls; let i = index"
      >
        <div class="row gap-8 w100 align-stretch space-between">
          <div class="row gap-8 w50">
            <rr-input
              class="w100 grow-1"
              type="text"
              [required]="true"
              label="Name of Export"
              [FormControl]="prompt.promptTypeControl"
            ></rr-input>
            <rr-select
              label="Output Type"
              optionName="name"
              optionValue="value"
              [control]="prompt?.outputType"
              preselectedValue="PDF"
              [options]="outputTypes"
            ></rr-select>
          </div>

          <div class="row gap-8">
            <rr-input
              class="creditcosts"
              type="number"
              label="Credits"
              [FormControl]="prompt.creditControl"
            ></rr-input>
            <rr-skipper
              (upActive)="(prompt.orderNr == 0 ? 'false' : 'true')"
              (downActive)="
                (prompt.orderNr == outputControls.length - 1 ? false : true)
              "
              class="align-self-end"
              (upClick)="outputControlUp(prompt)"
              (downClick)="outputControlDown(prompt)"
            ></rr-skipper>
          </div>
        </div>
        <textarea [formControl]="prompt?.control"></textarea>
        <div class="row w100 gap-8 space-between">
          <div class="w50 gap-8 row">
            <rr-select
              [options]="agents"
              optionName="name"
              class="grow-1"
              iconType="image"
              optionValue="id"
              [preselectedValue]="prompt?.agentControl?.value"
              [control]="prompt?.agentControl"
            ></rr-select>
            <rr-select
              placeholder="Status"
              [options]="promptStati"
              [control]="prompt?.status"
              optionName="name"
              optionValue="value"
              preselectedValue="ACTIVE"
            ></rr-select>
          </div>
          <rr-btn
            iconStart="trash"
            type="Secondary"
            (click)="deleteStreamPrompt(prompt.id)"
            >Delete</rr-btn
          >
        </div>
      </div>
    </div>
    <mat-action-row class="gap-8">
      <rr-btn iconStart="add" type="Secondary" (click)="addOutoutputControl()"
        >Add Output</rr-btn
      >
      <rr-btn iconStart="save" type="Primary" (click)="saveOutoutputControl()"
        >Save</rr-btn
      >
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>

<rr-spinner *ngIf="!hidespinner"></rr-spinner>
